import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import { ITipoAtividades } from "../../../../../../Interfaces/Geral/TipoAtividades";
import { DeletarTipoAtividadesController } from "../../../../../../Controllers/Geral/TipoAtividades";
import Table from "../../../../../Table";
import Swal from "sweetalert2";
import { IPropsTableChange } from "../../../../../../Interfaces/Geral/Atendimento/AtendimentoInterfaces";

interface IListagemTipoAtividadesProps {
    lstTipoAtividades: Array<ITipoAtividades> | undefined;
    lstTipoAtividadesLoading: boolean;
    setEdit: (tpa: ITipoAtividades) => void;
    updateListTipoAtividades: () => void;

    pesquisaText: string;
    setPesquisaText: (value: string) => void;
    handleSearch(searchValue: string, newState: IPropsTableChange): void;
}

export default function ListagemTipoAtividades(
    props: IListagemTipoAtividadesProps
) {
    function updateListTipoAtividades() {
        props.updateListTipoAtividades();
    }

    const columns: Array<ColumnDescription<ITipoAtividades>> = [
        {
            dataField: "DS_TIPO_ATIVIDADE",
            text: "Tipos de Atividades",
            formatter: rowTipoAtividade,
            sort: true,
        },
        {
            dataField: "button",
            text: "Editar",
            formatExtraData: props.setEdit,
            formatter: (c, row, _, setEdit) => (
                <div className="d-flex justify-content-center align-items-center p-2">
                    <button
                        className="btn btn-outline-primary"
                        onClick={() => {
                            setEdit(row);
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                    </button>
                </div>
            ),
        },
        {
            dataField: "button",
            text: "Deletar",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex justify-content-center align-items-center p-2">
                    <button
                        className="btn btn-outline-danger"
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja apagar este Tipo Atividade?",
                                icon: "info",
                                buttonsStyling: false,
                                confirmButtonText:
                                    "<i class='la la-check'></i> Sim!",
                                showCancelButton: true,
                                cancelButtonText:
                                    "<i class='la la-thumbs-down'></i> Não",
                                customClass: {
                                    confirmButton: "btn btn-outline-success",
                                    cancelButton: "btn btn-default",
                                },
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    DeletarTipoAtividadesController(
                                        row.ID_TIPO_ATIVIDADE
                                    ).then(() => {
                                        updateListTipoAtividades();
                                    });
                                }
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} size="lg" />
                    </button>
                </div>
            ),
        },
    ];

    function rowTipoAtividade(
        cell: string,
        row: ITipoAtividades,
        setEdit: any
    ) {
        return (
            <div className="d-flex flex-column g-1">
                <div className="d-flex align-items-center">
                    <i className={`${row.DS_ICONE} text-dark mr-2`} />
                    <h6 className="d-flex justify-content-center align-items-center pt-2">
                        {row.DS_TIPO_ATIVIDADE}
                    </h6>
                </div>
                <div className="d-flex align-items-center gap-2">
                    <span className={`badge badge-primary text-white mr-2`}>
                        {row.DS_TIPO_CASO}
                    </span>
                    {row.FL_LIGACAO && (
                        <span className="badge badge-success text-white">
                            Ligação
                        </span>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="col-12 mt-5">
            <Table
                keyField="ID_TIPO_ATIVIDADE"
                columns={columns}
                data={props.lstTipoAtividades ?? []}
                loading={props.lstTipoAtividadesLoading}
                noDataIndication={
                    <div className="text-center text-muted">
                        Nenhum Tipo de Atividade
                    </div>
                }
                wrapperClasses="wrapperTable mw-100 x-scroll"
                classes="tableClasses"
                bordered={false}
                defaultStyle={{
                    align: "center",
                    classes: "p-2",
                }}
                sizePerPage={5}
                onTableChange={(_type, newState) => {
                    const state = newState as IPropsTableChange;

                    if (state.searchText !== props.pesquisaText) {
                        props.handleSearch(state.searchText, state);
                        props.setPesquisaText(state.searchText);
                    }
                }}
                remote={{
                    search: true,
                }}
            />
        </div>
    );
}
